import * as React from 'react'

import {
  Box,
  Colors,
  Dimensions,
  ThemeColors,
  useToggle,
} from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import AddNewBlockWizard from 'modules/attendance/components/CustomTimeRanges/Content/Table/Modals/AddNewBlockWizard'
import DeleteTimeBlockModal from 'modules/attendance/components/CustomTimeRanges/Content/Table/Modals/DeleteTimeBlockModal'
import useFetchData from 'modules/attendance/components/SettingItemPage/TimeTracking/TimeTrackingPolicy/useFetchData'
import { CustomTimeRange } from 'modules/attendance/hooks/useFetchCustomTimeRanges'

import TagsContent from './TagsContent'

interface Props {
  range: CustomTimeRange
  base: boolean
}

interface PopoverSettings {
  background: Colors | ThemeColors
  dateRange: string | null
  paddingBottom: Dimensions | undefined
  paddingTop: Dimensions | undefined
  paddingX: Dimensions | undefined
}

const BlockContent = ({ range, base }: Props) => {
  const [open, toggle] = useToggle(false)
  const [openEditModal, setOpenEditModal] = React.useState(false)
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false)
  const [hover, setHover] = React.useState<boolean>(false)
  const onMouseEnter = () => setHover(true)
  const onMouseLeave = () => setHover(false)
  const {
    company: { id: currentCompanyId },
  } = useCurrentSession()

  const { currentSetting } = useFetchData(range.attendanceEmployeesSettingId)

  const customBackround = hover ? 'grey200' : 'grey000White'
  let popoverSettings: PopoverSettings

  if (base) {
    popoverSettings = {
      background: 'grey100',
      dateRange: null,
      paddingBottom: undefined,
      paddingTop: 's8',
      paddingX: undefined,
    }
  } else {
    popoverSettings = {
      background: customBackround,
      dateRange: range.rangeKey,
      paddingBottom: 's8',
      paddingTop: 's12',
      paddingX: 's12',
    }
  }

  return (
    <>
      <PopoverMenu type="list" onClick={toggle(!open)} open={open}>
        <PopoverMenu.Trigger>
          <Box
            onClick={toggle(true)}
            gap="s8"
            alignItems="flexStart"
            justifyContent="spaceBetween"
            background={popoverSettings.background}
            border={
              base
                ? undefined
                : {
                    all: {
                      width: 's1',
                      style: 'solid',
                      color: 'grey400',
                    },
                  }
            }
            borderRadius={{
              all: 'abs008',
            }}
            paddingX={popoverSettings.paddingX}
            paddingTop={popoverSettings.paddingTop}
            paddingBottom={popoverSettings.paddingBottom}
            cursor="pointer"
            maxWidth="full"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          >
            <TagsContent dateRange={popoverSettings.dateRange} range={range} />
          </Box>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="center">
          <PopoverMenu.TouchableOption
            title={i18n.t('common.edit')}
            onClick={() => setOpenEditModal(true)}
          />
          <PopoverMenu.TouchableOption
            title={i18n.t('common.delete')}
            onClick={() => setOpenDeleteModal(true)}
            danger
          />
        </PopoverMenu.Content>
      </PopoverMenu>
      {openEditModal && (
        <AddNewBlockWizard
          settingId={range.attendanceEmployeesSettingId}
          range={range}
          onClose={() => setOpenEditModal(false)}
        />
      )}
      {openDeleteModal && currentSetting && (
        <DeleteTimeBlockModal
          attendanceSetting={currentSetting}
          companyId={currentCompanyId}
          range={range}
          onClose={() => setOpenDeleteModal(false)}
        />
      )}
    </>
  )
}

export default BlockContent
